/**
 * @generated SignedSource<<53fee7939b3db3af3b7ca7f0e00f8d88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Chain = "Arbitrum" | "Ethereum" | "Optimism" | "POAP" | "Polygon" | "Tezos" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type walletGetExternalAddressLinkFragment$data = {
  readonly address: string | null;
  readonly chain: Chain | null;
  readonly " $fragmentType": "walletGetExternalAddressLinkFragment";
};
export type walletGetExternalAddressLinkFragment$key = {
  readonly " $data"?: walletGetExternalAddressLinkFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"walletGetExternalAddressLinkFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "walletGetExternalAddressLinkFragment"
};

(node as any).hash = "7ffccd1f5bbbf38b57eb3d6be693c46a";

export default node;
